
import {Grid} from "@mui/material";
import Barra from "./Barra/Barra";
import {BrowserRouter as Router, Route, Routes} from 'react-router-dom';
import Seccion_Home from "./Secciones/Seccion_Home";
import Footer from "./Footer";
import Seccion_Trabajo from "./Secciones/Seccion_Trabajo";
import Seccion_Nosotros from "./Secciones/Seccion_Nosotros";
import Seccion_Blog from "./Secciones/Seccion_Blog";
import Seccion_Blog_Post from "./Secciones/Seccion_Blog_Post";
import Seccion_Servicio_Detalle from "./Secciones/Seccion_Servicio_Detalle";
import Seccion_Politicas from "./Secciones/Seccion_Politicas";
import Seccion_Terminos from "./Secciones/Seccion_Terminos";
import Seccion_Cookies from "./Secciones/Seccion_Cookies";
import Seccion_Contacto from "./Secciones/Seccion_Contacto";

const Pagina = () => {

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={12}>


            <Router>

                {/*<Grid container size={12} sx={{zIndex: 2}}>*/}
                {/*    <Barra/>*/}
                {/*</Grid>*/}

                <Routes>
                    <Route path={"*"} element={<Seccion_Home/>}/>
                    <Route path={"/"} element={<Seccion_Home/>}/>
                    <Route path={"/home"} element={<Seccion_Home/>}/>
                    <Route path={"/proyectos"} element={<Seccion_Trabajo/>}/>
                    <Route path={"/sobre-mi"} element={<Seccion_Nosotros/>}/>
                    <Route path={"/blog"} element={<Seccion_Blog/>}/>
                    <Route path={"/contacto"} element={<Seccion_Contacto/>}/>
                    <Route path="/blog/:id" element={<Seccion_Blog_Post />} />
                    <Route path="/servicios/:id" element={<Seccion_Servicio_Detalle />} />
                    <Route path="/politica-de-privacidad" element={<Seccion_Politicas />} />
                    <Route path="/terminos-y-condiciones" element={<Seccion_Terminos />} />
                    <Route path="/politica-de-cookies" element={<Seccion_Cookies />} />

                </Routes>

                {/*<Grid container size={12} >*/}
                {/*    <Footer/>*/}
                {/*</Grid>*/}

            </Router>

        </Grid>
    )

}
export default Pagina